import styled from '@emotion/styled'
import Modal from '@/components/common/Modal'

export const ModalWrapper = styled(Modal)`
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  height: 100%;
  max-height: 800px;

  .ant-modal-content {
    border-radius: 12px;
  }

  .ant-modal-body {
    padding: 0px !important;
  }

  .ant-modal-header {
    border-radius: 12px 12px 0 0;
    margin-bottom: 0px !important;
  }
`

export const DownloadWrapper = styled('div')`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 1000;
  cursor: pointer;
`

export const ArrowLeftWrapper = styled('div')`
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 1000;
  cursor: pointer;
`

export const IconSvg = styled('img')`
  margin-right: 10px;
  height: 20px;
  width: 20px;
`
